module.exports = __webpack_public_path__ + "static/img/afs.114ba4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/afs.png
// module id = vfn4
// module chunks = 0